/* eslint-disable no-console */
/* eslint-disable @calm/react-intl/missing-formatted-message */
/* eslint-disable no-param-reassign */
/* eslint-disable import/extensions */
import {
  AsyncHelper,
  DateHelper,
  DomHelper,
  DragHelper,
  EventHelper,
  ResourceModel,
  Tooltip,
  WidgetHelper,
} from '@bryntum/schedulerpro';
import { BryntumSchedulerPro } from '@bryntum/schedulerpro-react';
import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import CollapseCategories16 from '@carbon/icons-react/es/collapse-categories/16';
import ExpandCategories16 from '@carbon/icons-react/es/expand-categories/16';
import { Col, Dropdown, Row } from 'antd';
import moment from 'moment';
import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { Menu } from 'components/atoms/dropdown';
import { InputNumber } from 'components/atoms/input';
import { formatTime } from 'components/organisms/timesheets/common/format-time';
import { floatUid } from 'utils/uid';
import {
  EventMoreDropdown,
  getTooltipForEvent,
  ProjectName,
  UserName,
} from './name-cells';
import {
  getAllocationEventsForUser,
  getEventsForProject,
  getRandomProjects,
  getRandomTeamMember,
  populateOverAllocation,
} from './random-data';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;
const SchedulerPro = styled.div`
  width: 100%;
  height: 100%;
  .placeholder {
    height: 32px;
    background-color: #0f62fe;
    position: absolute;
    border-radius: 4px;
    z-index: 1;
    cursor: pointer;
    &.b-drag-original {
      z-index: 3;
      cursor: ew-resize;
    }
  }
  .b-sch-event-wrap {
    z-index: 2;
    &.project-timeline {
      height: 6px;
    }
    &.project-phase {
      top: 8px;
      height: 24px;
    }
    &.allocation {
      height: 32px;
    }
    &.empty-record {
      top: -8px;
      height: 48px;
      .b-sch-event {
        margin: 8px 0;
      }
      .b-sch-event-content {
        pointer-events: none;
        margin: 0;
        display: flex;
        justify-content: center;
        width: 100%;
        .content {
          color: white;
        }
      }
    }
    &.task-intensity {
      top: 34px;
      height: 6px;

      .b-sch-event {
        border-radius: 0;
        width: 100%;
        background-color: transparent;
        &:hover {
          background-color: transparent;
        }
        .intensity-bar {
          height: 6px;
        }
        .level-1 {
          background-color: var(--yellow-20);
        }
        .level-2 {
          background-color: var(--yellow-20);
        }
        .level-3 {
          background-color: var(--yellow-30);
        }
        .level-4 {
          background-color: var(--yellow-30);
        }
        .level-5 {
          background-color: var(--yellow-40);
        }
        .level-6 {
          background-color: var(--yellow-40);
        }
        .level-7 {
          background-color: var(--yellow-50);
        }
        .level-8 {
          background-color: var(--yellow-50);
        }
        .level-9 {
          background-color: var(--yellow-60);
        }
      }
    }
  }
  .b-sch-event {
    border-radius: 4px;

    .more-actions-container {
      display: none;
      position: absolute;
      right: 0;
      top: 0;
    }

    &:hover:not(.splitMode) .more-actions-container,
    &.isActive .more-actions-container {
      display: block;
    }
    .splitter {
      display: block;
      border-right: 2px dashed white;
      position: absolute;
      top: 0;
      bottom: 0;
      transform: translateX(-1px);
      overflow: visible;
      .white-bar {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 8px;
        background: #fff;
        transform: translateX(-4px);
        z-index: 1;
      }
      &:before,
      &:after {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 10px;
        border-radius: 4px;
        background: #d0e2fe;
        background-image: linear-gradient(
          rgba(0, 0, 0, 0.1),
          rgba(0, 0, 0, 0.1)
        );
        z-index: 2;
      }
      &:before {
        transform: translateX(-10px);
      }
      &:after {
        transform: translateX(2px);
      }
      &:hover {
        .white-bar {
          display: block;
        }
        &:before,
        &:after {
          content: '';
        }
      }
    }
  }
  .b-sch-event-content {
    color: #161616 !important;
    margin: 0;
    width: 100%;
    height: 100%;
    .content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
  .over-allocation-bar {
    background: #f44d56;
    position: absolute;
    top: 0;
    border-radius: 4px 4px 0px 0px;
    height: 4px;
    border-bottom: 1px solid #fff;
  }
  .b-grid-subgrid-locked {
    .b-grid-row.non-collapsible {
      background: #f9f9fa;
      color: #525252;
      pointer-events: none;
      .b-tree-expander {
        display: none;
      }
    }
  }
  .b-timeline-subgrid {
    background: none !important;
  }
`;

const zoomPresets = [
  {
    base: 'monthAndYear',
    id: 'myMonthAndYear',
    incrementBy: 'month',
    timeResolution: {
      unit: 'day',
      increment: 1,
    },
  },
  {
    base: 'weekAndDay',
    id: 'myMonthWeekAndDay',
    incrementBy: 'day',
    timeResolution: {
      unit: 'day',
      increment: 1,
    },
    tickWidth: 48,
    defaultSpan: 15,
    headers: [
      {
        unit: 'month',
        increment: 1,
        renderer: (date) => {
          return moment(date).format("MMM' YY");
        },
      },
      {
        unit: 'week',
        increment: 1,
        renderer: (date) => {
          return moment(date).format('DD');
        },
      },
      {
        unit: 'day',
        increment: 1,
        renderer: (date) => {
          return moment(date).format('dd');
        },
      },
    ],
  },
  {
    base: 'weekAndDay',
    id: 'myMonthAndDay',
    incrementBy: 'day',
    timeResolution: {
      unit: 'day',
      increment: 1,
    },
    tickWidth: 48,
    defaultSpan: 15,
    headers: [
      {
        unit: 'month',
        increment: 1,
        renderer: (date) => {
          return moment(date).format("MMM' YY");
        },
      },
      {
        unit: 'day',
        increment: 1,
        renderer: (date) => {
          return moment(date).format('D');
        },
      },
    ],
  },
];

export const Scheduler: FC = () => {
  const ref = useRef<any>();
  const dateToPx = (date, left) =>
    (ref.current as unknown as any)?.instance.getCoordinateFromDate(date) -
    left;
  const [onlyProjects, setOnlyProjects] = useState(false);
  const onlyProjectsRef = useRef<any>();

  const [allocations, setAllocations] = useState<any[]>([]);
  const allocationsRef = useRef<any>();
  const draggingRef = useRef<boolean>();
  const originalProps = useRef<any>();

  const projectPhaseTooltip = useMemo(
    () =>
      new Tooltip({
        forSelector: '.b-sch-event .content',
        getHtml: (params) => {
          const { event } = params;
          const eventId = event.target.getAttribute('data-event-id');
          const allocationEvent =
            ref.current?.instance.eventStore.getById(eventId);

          if (allocationEvent) {
            return getTooltipForEvent(allocationEvent);
          }

          return null;
        },
        hoverDelay: 100,
        hideDelay: 100,
      }),
    [],
  );

  const overAllocation = useMemo(
    () =>
      new Tooltip({
        forSelector: '.over-allocation-bar',
        getHtml: (event) => {
          return event.activeTarget.getAttribute('data-tooltip');
        },
        hoverDelay: 100,
        hideDelay: 100,
      }),
    [],
  );
  const intensityTooltip = useMemo(
    () =>
      new Tooltip({
        forSelector: '.intensity-bar',
        getHtml: (params) => {
          const { event } = params;
          const number = event.target?.getAttribute('data-task-number');

          return number ? `Number of tasks assigned: ${number}` : null;
        },
        hoverDelay: 100,
        hideDelay: 100,
      }),
    [],
  );

  const placeholder = useMemo(
    () =>
      DomHelper.createElement({
        tag: 'div',
        className: 'placeholder',
        style: 'height: 32px;',
      }),
    [],
  );

  const addNewAllocation = useCallback((startDate, endDate, resourceId) => {
    const newEvent = {
      name: '8h/d',
      id: floatUid(),
      startDate,
      endDate,
      minutesPerDay: 8 * 60,
      resourceId,
      eventColor: '#D0E2FF',
      cls: 'allocation',
      type: 'allocation',
      overAllocations: [],
    };
    const [, userId] = resourceId.split('_userId_');

    allocationsRef.current.push(newEvent);

    const collidingEvents = getAllocationEventsForUser(
      allocationsRef.current,
      userId,
      startDate,
      endDate,
    );

    collidingEvents.forEach((event) => {
      if (event.resourceId !== resourceId || event.id === newEvent.id) {
        return;
      }
      const startDateIsBetween = moment(event.startDate).isBetween(
        moment(startDate),
        moment(endDate),
        'day',
        '[]',
      );
      const endDateIsBetween = moment(event.endDate).isBetween(
        moment(startDate),
        moment(endDate),
        'day',
        '[]',
      );

      if (startDateIsBetween && endDateIsBetween) {
        event.minutesPerDay = 0;
      } else if (startDateIsBetween) {
        event.startDate = moment(endDate).add(1, 'day').startOf('day').toDate();
        event.endDate = moment(event.endDate).toDate();
        // record.setStartDate(moment(endDate).toDate());
        // record.setEndDate(event.endDate);
      } else if (endDateIsBetween) {
        event.startDate = moment(event.startDate).toDate();
        event.endDate = moment(startDate)
          .subtract(1, 'day')
          .endOf('day')
          .toDate();
        // record.setStartDate(event.startDate);
        // record.setEndDate(moment(startDate).toDate());
      }
    });
    populateOverAllocation(collidingEvents, 8 * 60, startDate, endDate);
    collidingEvents.forEach((allocationEvent) => {
      const record = ref.current.instance.eventStore.getById(
        allocationEvent.id,
      );

      if (allocationEvent.minutesPerDay === 0) {
        ref.current.instance.eventStore.remove(record);
      } else if (record) {
        record.setStartDate(allocationEvent.startDate);
        record.setEndDate(allocationEvent.endDate);
        record.set('overAllocations', allocationEvent.overAllocations);
      } else {
        ref.current.instance.eventStore.add(allocationEvent);
      }
    });
  }, []);

  useEffect(() => {
    EventHelper.addListener(placeholder as HTMLElement, 'click', (event) => {
      const { left, width } = DomHelper.getStyleValue(
        placeholder as HTMLElement,
        ['left', 'width', 'top'],
      ) as { left: string; width: string; top: string };
      const startDate = ref.current.instance.getDateFromCoordinate(
        parseInt(left, 10),
      );
      const endDate = ref.current.instance.getDateFromCoordinate(
        parseInt(left, 10) + parseInt(width, 10),
      );
      const [, y] = EventHelper.getXY(event);
      const rowElement = document.elementFromPoint(50, y);
      const resource = ref.current.instance.resolveResourceRecord(rowElement);

      addNewAllocation(
        moment(startDate).startOf('day').toDate(),
        moment(endDate).endOf('day').toDate(),
        resource.id,
      );
    });
  }, [addNewAllocation, placeholder]);

  useEffect(() => {
    const dragHelper = new DragHelper({
      mode: 'translateXY',
      targetSelector: '.placeholder',
      cloneTarget: true,
      lockY: true,
      listeners: {
        beforeDragStart: () => {
          draggingRef.current = true;
          ref.current.instance.enableScrollingCloseToEdges(
            ref.current.instance.timeAxisSubGrid,
          );
        },
        drag: (event) => {
          if (!originalProps.current) {
            return;
          }
          const { elementX, newX } = event.context;
          const { width, left } = originalProps.current;
          let newWidth = width;
          let newLeft = left;

          if (newX > elementX) {
            newWidth = width + (newX - elementX);
          } else {
            newWidth = width + (elementX - newX);
            newLeft = left - (elementX - newX);
          }

          DomHelper.applyStyle(placeholder as HTMLElement, {
            width: `${newWidth}px`,
            left: `${newLeft}px`,
          });
        },
        drop: (event) => {
          const { left, width } = DomHelper.getStyleValue(
            placeholder as HTMLElement,
            ['left', 'width'],
          ) as { left: string; width: string };
          const startDate = ref.current.instance.getDateFromCoordinate(
            parseInt(left, 10),
          );
          const endDate = ref.current.instance.getDateFromCoordinate(
            parseInt(left, 10) + parseInt(width, 10),
          );
          const rowElement = document.elementFromPoint(
            50,
            event.context.elementStartY,
          );
          const resource =
            ref.current.instance.resolveResourceRecord(rowElement);

          addNewAllocation(
            moment(startDate).startOf('day').toDate(),
            moment(endDate).endOf('day').toDate(),
            resource.id,
          );
          event.context.finalize(true);
          draggingRef.current = false;
          ref.current.instance.disableScrollingCloseToEdges(
            ref.current.instance.timeAxisSubGrid,
          );
        },
      },
    });

    return () => dragHelper.destroy();
  }, [addNewAllocation, placeholder]);

  useEffect(() => {
    allocationsRef.current = allocations;
  }, [allocations]);

  useEffect(() => {
    onlyProjectsRef.current = onlyProjects;
  }, [onlyProjects]);

  // const projectModel = useMemo(
  //   () =>
  //     new ProjectModel({
  //       eventStore: new EventStore({
  //         useRawData: true,
  //         syncDataOnLoad: true,
  //       }),
  //       resourceStore: new ResourceStore({
  //         useRawData: true,
  //       }),
  //     }),
  //   [],
  // );
  const schedulerConfig = {
    // project: projectModel,
    infiniteScroll: true,
    rowHeight: 64,
    barMargin: 12,
    // startDate: new Date(2020, 1, 1),
    // endDate: new Date(2020, 2, 1),
    eventLayout: { type: 'none' },
    viewPreset: 'myMonthWeekAndDay',
    presets: zoomPresets,
    managedEventSizing: false,
    horizontalEventSorterFn: (a, b) => {
      const aType = a.originalData.type;
      const bType = b.originalData.type;

      if (aType === 'project') {
        return -1;
      }
      if (bType === 'project') {
        return 1;
      }

      return 0;
    },
    listeners: {
      // beforeRenderRows: ({ source }) => {
      //   // source.eventStore.filter({
      //   //   filters: (x) => {
      //   //     console.log('beforeRenderRows');
      //   //     return x.get('type') !== 'project-phase';
      //   //   },
      //   //   replace: true,
      //   // });
      // },
      collapseNode: (event) => {
        if (event.record.originalData.type === 'role') {
          event.source.expand(event.record.id);
        }
      },
      beforeDestroy: () => {
        projectPhaseTooltip.destroy();
        overAllocation.destroy();
        intensityTooltip.destroy();
      },
      beforeToggleNode: (event) => {
        if (event.record.type === 'project' && event.collapse === false) {
          event.record.children.forEach(({ id }) => {
            event.source.expand(id);
          });
          if (onlyProjectsRef.current) {
            ref.current.instance.suspendRefresh();
            ref.current.instance.eventStore.beginBatch();
            const events: any[] = [];

            event.record.children.forEach(({ children }) => {
              children.forEach(({ id: resource }) => {
                events.push(
                  ...allocationsRef.current.filter(
                    ({ resourceId }) => resourceId === resource,
                  ),
                );
              });
            });
            ref.current.instance.eventStore.add(events, true);
            ref.current.instance.eventStore.endBatch(true);
            ref.current.instance.resumeRefresh(true);
          }
        }

        return false;
      },
      toggleNode: (event) => {
        if (event.record.originalData.type !== 'project') {
          return;
        }
        const node = ref.current.instance.resourceStore.getById(
          event.record.id,
        ) as ResourceModel;

        if (event.collapse) {
          node.resourceMargin = 21;
        } else {
          node.resourceMargin = 0;
        }
        // (ref.current as unknown as any)?.instance.eventStore.filter({
        //   filters: (x) => {
        //     const { resource, type } = x;

        //     if (resource && resource.isExpanded()) {
        //       return true;
        //     }

        //     return type !== 'project-phase';
        //   },
        //   replace: true,
        // });
      },
      // eventDrag: (arg) => {
      //   const { draggedRecords, startDate, endDate, resourceRecord } = arg;

      //   const eventRecord = draggedRecords[0];

      //   if (eventRecord && eventRecord.id === 'empty_record') {
      //     const startDateBeforeDrag = eventRecord.get('startDateBeforeDrag');
      //     const endDateBeforeDrag = eventRecord.get('endDateBeforeDrag');

      //     projectModel.eventStore.add({
      //       id: 'dragging_empty_record',
      //       type: 'empty_record',
      //       startDate: moment(startDate).isBefore(startDateBeforeDrag)
      //         ? startDate
      //         : startDateBeforeDrag,
      //       endDate: moment(endDate).isAfter(endDateBeforeDrag)
      //         ? endDate
      //         : endDateBeforeDrag,
      //       resourceId: resourceRecord.id,
      //     });

      //     projectModel.eventStore.add({
      //       id: 'empty_record',
      //       type: 'empty_record',
      //       startDate: moment(startDate).isBefore(startDateBeforeDrag)
      //         ? startDate
      //         : startDateBeforeDrag,
      //       endDate: moment(endDate).isAfter(endDateBeforeDrag)
      //         ? endDate
      //         : endDateBeforeDrag,
      //       isDragging: true,
      //       resourceId: resourceRecord.id,
      //     });
      //   }
      // },
      // eventDragStart: (arg) => {
      //   const { draggedRecords, resourceRecord } = arg;

      //   const eventRecord = draggedRecords[0];

      //   if (eventRecord && eventRecord.id === 'empty_record') {
      //     projectModel.eventStore.add({
      //       id: 'dragging_empty_record',
      //       type: 'empty_record',
      //       startDate: eventRecord.get('startDate'),
      //       endDate: eventRecord.get('endDate'),
      //       resourceId: resourceRecord.id,
      //     });
      //     projectModel.eventStore.add({
      //       id: 'empty_record',
      //       type: 'empty_record',
      //       startDate: eventRecord.get('startDate'),
      //       endDate: eventRecord.get('endDate'),
      //       startDateBeforeDrag: eventRecord.get('startDate'),
      //       endDateBeforeDrag: eventRecord.get('endDate'),
      //       isDragging: true,
      //       resourceId: resourceRecord.id,
      //     });
      //   }
      // },
      // eventDrop: () => {
      //   const draggedEmptyRecord = projectModel.eventStore.getById(
      //     'dragging_empty_record',
      //   );

      //   if (draggedEmptyRecord) {
      //     projectModel.eventStore.add({
      //       name: '8h/d',
      //       startDate: draggedEmptyRecord.get('startDate'),
      //       endDate: draggedEmptyRecord.get('endDate'),
      //       type: 'allocation',
      //       resourceId: draggedEmptyRecord.get('resourceId'),
      //     });
      //     projectModel.eventStore.remove(draggedEmptyRecord);
      //     projectModel.eventStore.remove(
      //       projectModel.eventStore.getById('empty_record'),
      //     );
      //   }
      // },
      eventMouseOver: (arg) => {
        const { eventRecord, source } = arg;

        DomHelper.applyStyle(placeholder as HTMLElement, {
          display: 'none',
        });

        if (eventRecord == null) {
          return;
        }

        const moreActionContainer = document.querySelector(
          `[data-event-id="${eventRecord.id}"] .b-sch-event-content .more-actions-container`,
        );

        if (moreActionContainer) {
          ReactDOM.render(
            <EventMoreDropdown
              onSplit={() => {
                (source.eventStore.getById(eventRecord.id) as any).splitMode =
                  true;
              }}
              onRemove={() => {
                source.eventStore.remove(eventRecord);
              }}
              onVisibleChange={(isVisible) => {
                if (source.eventStore.getById(eventRecord.id) as any) {
                  (source.eventStore.getById(eventRecord.id) as any).active =
                    isVisible;
                }
              }}
            />,
            moreActionContainer,
          );
        }
      },

      eventClick: (arg) => {
        const { eventRecord, source } = arg;
        const { target } = arg.event;
        const splitAt = target.getAttribute('data-split-at');

        if (splitAt) {
          source.eventStore.beginBatch();
          eventRecord.splitMode = false;
          source.eventStore.add({
            name: eventRecord.name,
            id: floatUid(),
            startDate: new Date(splitAt),
            resourceId: eventRecord.resourceId,
            endDate: eventRecord.endDate,
            eventColor: '#D0E2FF',
            cls: 'allocation',
          });
          eventRecord.endDate = new Date(splitAt);
          source.eventStore.endBatch(true);
        }
      },
      // beforeEventDrag: (event) => {
      //   const { resourceRecord, eventRecord } = event;
      //   const resourceType = resourceRecord.get('type');

      //   if (resourceType === 'role' || resourceType === 'project') {
      //     return false;
      //   }
      //   if (eventRecord && eventRecord.id === 'empty_record') {
      //     projectModel.eventStore.add({
      //       id: 'dragging_empty_record',
      //       type: 'empty_record',
      //       startDate: eventRecord.get('startDate'),
      //       endDate: eventRecord.get('endDate'),
      //       resourceId: resourceRecord.id,
      //     });
      //   }

      //   return true;
      // },
      // beforeEventResize: (event) => {
      //   const { resourceRecord } = event;
      //   const resourceType = resourceRecord.get('type');

      //   return resourceType !== 'role' && resourceType !== 'project';
      // },
      beforeDragCreate: (event) => {
        const { resourceRecord } = event;
        const resourceType = resourceRecord.get('type');

        return resourceType !== 'role' && resourceType !== 'project';
      },
      beforeEventAdd: (event) => {
        const { eventRecord, source } = event;
        const resourceRecord = source.resourceStore.getById(
          eventRecord.resourceId,
        );

        eventRecord.name = '8h/d';
        eventRecord.type = 'allocation';
        eventRecord.eventColor = '#D0E2FF';
        eventRecord.cls = 'allocation';

        if (resourceRecord) {
          const resourceType = resourceRecord.get('type');

          return resourceType !== 'role' && resourceType !== 'project';
        }

        return true;
      },
      // eventMouseOut: (event) => {
      //   const { eventRecord, source } = event;

      //   if (
      //     eventRecord &&
      //     eventRecord.id === 'empty_record' &&
      //     !eventRecord.meta.isResizing
      //   ) {
      //     // source.eventStore.remove(eventRecord);
      //   }
      // },
      mouseOut: (event) => {
        const source = ref.current?.instance;
        const eventRecord = source?.eventStore.getById('empty_record');

        if (
          !event.event.toElement?.classList.contains('empty-record') &&
          eventRecord &&
          !eventRecord.meta.isResizing
        ) {
          source.eventStore?.remove(eventRecord);
        }
        // DomHelper.applyStyle(placeholder as HTMLElement, {
        //   display: 'none',
        // });
      },
      cellMouseOut: (event) => {
        if (
          event.event?.toElement?.classList.contains('placeholder') === false
        ) {
          DomHelper.applyStyle(placeholder as HTMLElement, {
            display: 'none',
          });
        }
      },
      scheduleMouseMove: (event) => {
        if (draggingRef.current) {
          return;
        }
        const { resourceRecord, tickStartDate, tickEndDate, source, row } =
          event;
        const resourceType = resourceRecord.get('type');

        const left = source.getCoordinateFromDate(tickStartDate, {
          local: true,
        });
        const width = source.getTimeSpanDistance(tickStartDate, tickEndDate);

        const top = row.top || DomHelper.getPageY(row.elements.locked);

        if (resourceType === 'project' || resourceType === 'role') {
          DomHelper.applyStyle(placeholder as HTMLElement, {
            display: 'none',
          });

          return;
        }
        originalProps.current = {
          left,
          width,
          top: top + 12,
        };

        DomHelper.applyStyle(placeholder as HTMLElement, {
          left: `${left}px`,
          width: `${width}px`,
          top: `${top + 12}px`,
          display: 'block',
        });

        // const resourceType = resourceRecord.get('type');
        // const emptyEventRecord = source.eventStore.getById('empty_record');

        // if (resourceType === 'project' || resourceType === 'role') {
        //   source.eventStore.remove(emptyEventRecord);

        //   return;
        // }
        // // if (emptyEventRecord && emptyEventRecord.get('isDragging')) {
        // //   return;
        // // }
        // if (emptyEventRecord) {
        //   ref.current.instance.eventStore.beginBatch();
        //   emptyEventRecord.startDate = tickStartDate;
        //   emptyEventRecord.endDate = tickEndDate;
        //   ref.current.instance.eventStore.endBatch(true);

        //   return;
        // }

        // source.eventStore.add(
        //   {
        //     id: 'empty_record',
        //     type: 'empty_record',
        //     startDate: tickStartDate,
        //     endDate: tickEndDate,
        //     // startDateBeforeDrag:
        //     //   emptyEventRecord && emptyEventRecord.get('isDragging')
        //     //     ? emptyEventRecord.get('startDateBeforeDrag')
        //     //     : tickStartDate,
        //     // endDateBeforeDrag:
        //     //   emptyEventRecord && emptyEventRecord.get('isDragging')
        //     //     ? emptyEventRecord.get('endDateBeforeDrag')
        //     //     : tickEndDate,
        //     // isDragging: emptyEventRecord && emptyEventRecord.get('isDragging'),
        //     resourceId: resourceRecord.id,
        //     eventColor: '#0F62FE',
        //     cls: 'empty-record',
        //   },
        //   true,
        // );
      },
      // eventMouseOut: (arg) => {
      //   const { eventRecord } = arg;
      //   const moreActionsContainer = document.querySelector(
      //     `[data-event-id="${eventRecord.id}"] .b-sch-event-content .more-actions-container`,
      //   );

      //   if (moreActionsContainer) {
      //     // ReactDOM.unmountComponentAtNode(moreActionsContainer);
      //   }
      // },
    },

    columns: [
      {
        text: 'Projects',
        width: 360,
        field: 'name',
        type: 'tree',
        renderer: (arg) => {
          const { record, size } = arg;

          if (record.originalData.type === 'role') {
            record.cls = 'non-collapsible';
            size.height = 32;
          }
          if (record.get('type') === 'project') {
            return (
              <ProjectName
                name={record.name}
                description={record.get('description')}
              />
            );
          }
          if (record.get('type') === 'user') {
            return <UserName name={record.name} />;
          }

          return record.name;
        },
      },
    ],

    features: {
      taskEdit: false,
      dependencies: false,
      tree: true,
      stickyEvents: false,
      eventDrag: {
        constrainDragToResource: true,
      },
      scheduleMenu: false,
      eventMenu: false,
      cellEdit: false,
      scheduleTooltip: false,
      eventTooltip: false,
      useInitialAnimation: false,
      enableEventAnimations: false,
      eventCopyPaste: false,
      eventFilter: false,
      cellMenu: false,
      columnPicker: false,
      group: false,
      headerMenu: false,
      timeAxisHeaderMenu: false,
      sort: false,
      eventDragCreate: false,
    },

    eventRenderer(arg) {
      const { eventRecord, renderData } = arg;
      const startDate = eventRecord.get('startDate');
      const endDate = eventRecord.get('endDate');

      renderData.wrapperCls.add(eventRecord.cls);
      renderData.cls.isActive = eventRecord.get('active');
      renderData.cls.splitMode = eventRecord.get('splitMode');

      const overAllocations = eventRecord.get('overAllocations');
      const intensities = eventRecord.get('intensities');
      const splitPositions: any[] = [];

      if (eventRecord.get('splitMode')) {
        const zoomLevel = (ref.current as unknown as any)?.instance.zoomLevel;
        const { incrementBy } = zoomPresets[zoomLevel];
        const startDateMoment = moment(startDate);
        const endDateMoment = moment(endDate);
        let increment = 1;

        while (
          startDateMoment
            .add(increment, incrementBy as any)
            .diff(endDateMoment, incrementBy as any) < 0
        ) {
          splitPositions.push({
            left: dateToPx(
              startDateMoment.add(increment, incrementBy as any).toDate(),
              renderData.left,
            ),
            date: startDateMoment.add(increment, incrementBy as any),
          });
          increment += 1;
        }
      }

      return {
        name:
          eventRecord.get('type') === 'allocation'
            ? `${formatTime(eventRecord.get('minutesPerDay'))}/d${
                eventRecord.name
              }`
            : eventRecord.name,
        type: eventRecord.get('type'),
        id: eventRecord.id,
        editMode: eventRecord.get('editMode'),
        splitPositions,
        overAllocationsData: (overAllocations ?? []).map((nestedEvent) => ({
          left: dateToPx(
            DateHelper.add(
              startDate,
              DateHelper.diff(
                eventRecord.get('startDate'),
                DateHelper.parse(nestedEvent.startDate, 'YYYY-MM-DD'),
              ),
            ),
            renderData.left,
          ),
          width: dateToPx(
            DateHelper.add(
              startDate,
              DateHelper.diff(
                DateHelper.parse(nestedEvent.startDate, 'YYYY-MM-DD'),
                DateHelper.parse(nestedEvent.endDate, 'YYYY-MM-DD'),
              ),
            ),
            renderData.left,
          ),
          overMinutes: nestedEvent.overMinutes,
        })),
        intensitiesData: (intensities || []).map((intensity) => ({
          left: dateToPx(
            DateHelper.add(
              startDate,
              DateHelper.diff(
                eventRecord.get('startDate'),
                DateHelper.parse(intensity.startDate, 'YYYY-MM-DD'),
              ),
            ),
            renderData.left,
          ),
          width: dateToPx(
            DateHelper.add(
              startDate,
              DateHelper.diff(
                DateHelper.parse(intensity.startDate, 'YYYY-MM-DD'),
                DateHelper.parse(intensity.endDate, 'YYYY-MM-DD'),
              ),
            ),
            renderData.left,
          ),
          cls: `level-${intensity.numberOfTasks}`,
          numberOfTasks: intensity.numberOfTasks,
        })),
      };
    },
    eventBodyTemplate: (record) => {
      return `<div class="content" data-event-id=${record.id}>${
        record.type === 'empty_record' ? '+' : record.name
      }</div>${(record.overAllocationsData ?? [])
        .map(
          (value) =>
            `<div class="over-allocation-bar" data-tooltip=${formatTime(
              value.overMinutes,
            )}over style="left: ${value.left}px;width: ${
              value.width
            }px"></div>`,
        )
        .join('')}${(record.intensitiesData ?? [])
        .map(
          (value) =>
            `<div class="intensity-bar ${value.cls}" data-task-number=${value.numberOfTasks} style="left: ${value.left}px;width: ${value.width}px"></div>`,
        )
        .join('')}${record.splitPositions
        .map(
          ({ date, left }) =>
            `<div class="splitter" style="left: ${left}px" data-split-at=${date.format(
              'YYYY-MM-DD',
            )}><div class="white-bar"></div></div>`,
        )
        .join('')}${
        record.type === 'allocation'
          ? '<div class="more-actions-container"></div>'
          : ''
      }`;
    },
  };
  const [limit, setLimit] = useState(5);

  const loadData = useCallback(
    async (noOfProjects: number) => {
      console.time('random data');
      const teamMembers = getRandomTeamMember(30);

      const projects = getRandomProjects(noOfProjects, teamMembers);
      const { events } = getEventsForProject(projects, teamMembers, 8 * 60);

      setAllocations(events);

      console.timeEnd('random data');

      const mask: any = WidgetHelper.mask(
        ref.current.instance.element,
        `Rendering ${events.length} events`,
      );

      await AsyncHelper.sleep(100);

      console.time('project data load');

      ref.current.instance.suspendRefresh();
      // await projectModel.loadInlineData({
      //   eventsData: events,
      //   resourcesData: projects,
      // });
      ref.current.instance.project = {
        resourceStore: {
          useRawData: true,
          data: projects,
        },
        eventStore: {
          useRawData: true,
          data: onlyProjectsRef.current
            ? events.filter(({ type }) => type === 'project')
            : events,
          syncDataOnLoad: true,
          singleAssignment: true,
        },
      };
      ref.current.instance.collapseAll();
      // ref.current.instance.eventStore.filter({
      //   filters: (x) => {
      //     return x.type === 'project';
      //   },
      //   replace: true,
      // });
      ref.current.instance.resumeRefresh(true);
      // await ref.current.instance.project.await('refresh');

      console.timeEnd('project data load');
      mask.close();
      DomHelper.append(
        ref.current.instance.timeAxisSubGridElement,
        placeholder,
      );
    },
    [placeholder],
  );

  useEffect(() => {
    loadData(5);
  }, [loadData]);

  return (
    <Wrapper>
      <Row>
        <Col xs={3}>
          <Checkbox
            checked={onlyProjects}
            onChange={() => setOnlyProjects((prev) => !prev)}
          >
            Load only project timeline
          </Checkbox>
        </Col>
        <Col xs={2}>Number of projects:</Col>
        <Col xs={4}>
          <InputNumber
            value={limit}
            onChange={(e) => setLimit(e as number)}
            onPressEnter={() => loadData(limit)}
          />
        </Col>
        <Col xs={2}>
          <Button
            type="text"
            icon={<ExpandCategories16 />}
            onClick={() => {
              if (onlyProjects) {
                ref.current.instance.eventStore.beginBatch();
                ref.current.instance.eventStore.add(allocations);
                ref.current.instance.eventStore.endBatch(true);
              }
              ref.current.instance.expandAll();
            }}
          />
          <Button
            type="text"
            icon={<CollapseCategories16 />}
            onClick={() => {
              ref.current.instance.collapseAll();
            }}
          />
        </Col>
        <Col xs={2}>
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="day"
                  onClick={() => {
                    ref.current.instance.viewPreset = 'myMonthAndDay';
                  }}
                >
                  Day
                </Menu.Item>
                <Menu.Item
                  key="week"
                  onClick={() => {
                    ref.current.instance.viewPreset = 'myMonthWeekAndDay';
                  }}
                >
                  Week
                </Menu.Item>
                <Menu.Item
                  key="month"
                  onClick={() => {
                    ref.current.instance.viewPreset = 'myMonthAndYear';
                  }}
                >
                  Month
                </Menu.Item>
              </Menu>
            }
          >
            <Button
              type="default"
              icon={<ChevronDown16 />}
              iconPlacement="right"
            >
              Select view
            </Button>
          </Dropdown>
        </Col>
      </Row>
      <SchedulerPro>
        <BryntumSchedulerPro ref={ref} {...schedulerConfig} />
      </SchedulerPro>
    </Wrapper>
  );
};
